import axios from 'axios'
import Constants from '@/js/constant'

const HOST = Constants.hosts.faurl
const timesheetAlerts = `${HOST}timesheet-alert`

export default {
  getTimesheetAlerts(context1, type) {
    const context = context1
    const params = { params: { type, page: context.$store.state.query.page - 1 } }
    axios.get(timesheetAlerts, params).then(response => {
      context.setTimesheetAlerts(response.data)
    }, () => {
    })
  },
  ignoreAlert(context1, id) {
    const context = context1
    context.$vs.loading()
    axios.get(`${timesheetAlerts}/${id}/ignore`).then(response => {
      context.$vs.loading.close()
      context.alertIgnored(response.data)
    }, error => {
      context.$vs.loading.close()
      context.alertNotIgnored(error.response.data.return_message)
    })
  },
}
